import { epicLoginNotificationServer } from "./epics/epicLoginNotificationServer";
export var epicNotification = epicLoginNotificationServer;



//////////////////
// WEBPACK FOOTER
// ./src/features/notifications/epicNotification.ts
// module id = 2025
// module chunks = 3